import React, { useState } from 'react'
import SpeechRecognition, { useSpeechRecognition } from 'react-speech-recognition';
import MicIcon from '@material-ui/icons/Mic';
import TextField from '@material-ui/core/TextField';

import './Vocal.css';

const Vocal = () => {
  const { transcript, resetTranscript } = useSpeechRecognition()
  const [flag, setFlag] = useState(false);
  const toggle = () => {
    resetTranscript();
    setFlag(() => true);
    let control = '';
    SpeechRecognition.startListening({ language: 'fa_IR' });
    setTimeout(() => {
      if(true){
        SpeechRecognition.stopListening();
        setFlag(() => false);
      }
    },5000)
    
  }

  const _closeVocalModal = (e) => {
    alert('2');
    setFlag(() => false);
    SpeechRecognition.stopListening();
  }

  function _openVocalModal(e){
    alert('1');
    setFlag(() => true);
    e.preventDefault()
  }

  return (
    <div>
      <MicIcon
        onClick={toggle}
        style={flag ? { position: 'absolute', left: 15, top: 1, width: 25, height: 25, color: '#00ff00' } : { position: 'absolute', left: 15, top: 1, width: 25, height: 25, color: '#0000ff' }}
      />
      <input defaultValue={transcript} />
      { 
        flag ? 
        <div className="vocal-modal d-flex" onClick={() => _closeVocalModal()}>
          <div className="vocal-modal__content d-flex flex-column" onClick={e => _openVocalModal(e)}>
            <div className="vocal-modal__content--toggle d-flex" style={{ backgroundColor: '#0000ff'+'11' }}>
              <MicIcon
                style= {{ color: '#0000ff',width : '100px', height : '100px'  }}
              />
            </div>
            <div className="vocal-modal__content--input">
              <input type="text" placeholder="در حال تشخیص صدا ..." value={transcript}/>
            </div>
          </div>
      </div> : null
      }
    </div >
  )
}
export default Vocal;